import { render, staticRenderFns } from "./Game1-1.vue?vue&type=template&id=52df98e0&scoped=true&"
import script from "./Game1-1.vue?vue&type=script&lang=js&"
export * from "./Game1-1.vue?vue&type=script&lang=js&"
import style0 from "./Game1-1.vue?vue&type=style&index=0&id=52df98e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df98e0",
  null
  
)

export default component.exports